import { Component, Input, OnDestroy, OnInit, signal } from '@angular/core';

const PHRASES = [
  'Preparando tu espacio…',
  'Ordenando las ideas…',
  'Puliendo los detalles…',
  'Trazando tu mapa…',
  'Dando los últimos toques…',
  'Ya casi está…'
];

@Component({
  selector: 'loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit, OnDestroy {
  @Input() visible = true;

  phrase = signal(PHRASES[0]);
  phraseVisible = signal(true);

  private phraseIndex = 0;
  private rotateTimer?: ReturnType<typeof setInterval>;
  private fadeTimer?: ReturnType<typeof setTimeout>;

  ngOnInit(): void {
    this.rotateTimer = setInterval(() => {
      this.phraseVisible.set(false);
      this.fadeTimer = setTimeout(() => {
        this.phraseIndex = (this.phraseIndex + 1) % PHRASES.length;
        this.phrase.set(PHRASES[this.phraseIndex]);
        this.phraseVisible.set(true);
      }, 280);
    }, 2600);
  }

  ngOnDestroy(): void {
    clearInterval(this.rotateTimer);
    clearTimeout(this.fadeTimer);
  }
}
